export default __webpack_public_path__ + "static/media/WHITE.03fa3b4a.png";